<div class="d-flex">
    <div class="side-banner">
        <span class="title">{{ 'journey_banner_title' | translate }}</span>
        <span class="subtitle">{{ 'journey_banner_subtitle' | translate }}</span>
        <img src="assets/images/homepage/fyes-logo-white.png" class="cursor-pointer" alt="" (click)="goToStep(0)">
    </div>
    <div class="journey-content">
        @switch (currentStep) {

        <!-- Space type selection-->
        @case (1) {
        <div id="step1">
            <div class="texts">
                <span class="title">{{ 'journey_step1_title' | translate }}</span>
                <span class="subtitle">{{ 'journey_step1_subtitle' | translate }}</span>
            </div>
            <div class="cards-wrapper">
                @for (spaceType of spaceTypes; track $index) {
                <div class="card cursor-pointer" (click)="selectSpace(spaceType)"
                    [ngClass]="{'selected': selectedSpaceType === spaceType}">
                    <div class="rounded-bg"><img [src]="spaceType.imageUrl" alt=""></div>
                    <div class="text-area">
                        <span class="title">{{ spaceType.title }}</span>
                        <span class="subtitle">{{ spaceType.description }}</span>
                    </div>
                </div>
                }
            </div>
        </div>

        }

        <!-- Space details-->
        @case (2) {
        <div id="step2">
            <div class="texts">
                <span class="title">{{ 'journey_step2_title' | translate }}</span>
                <span class="subtitle">{{ 'journey_step2_subtitle' | translate }}</span>
            </div>
            <div class="input-area mt-3">
                <span class="label">{{ 'journey_step2_rooms_label' | translate }}</span>
                <ng-select [items]="spaceRooms" bindLabel="label" [placeholder]="'journey_step2_rooms_placeholder' | translate"
                    class="fyes-select" [searchable]="false" [clearable]="false" [(ngModel)]="selectedRooms">
                    <ng-template ng-label-tmp let-item="item">{{ item.labelKey | translate }}</ng-template>
                    <ng-template ng-option-tmp let-item="item">{{ item.labelKey | translate }}</ng-template>
                </ng-select>
            </div>
            <div class="input-area">
                <span class="label">{{ 'journey_step2_size_label' | translate }}</span>
                <input type="number" class="fyes-input" [placeholder]="'journey_step2_size_placeholder' | translate" [(ngModel)]="selectedSize">
            </div>
        </div>
        }

        <!-- Automation selection-->
        @case (3) {
        <div id="step3">
            <div class="texts">
                <span class="title">{{ 'journey_step3_title' | translate }}</span>
                <span class="subtitle">{{ 'journey_step3_subtitle' | translate }}</span>
            </div>
            <div class="automations-wrapper">
                @for (automation of automations; track $index) {
                <div class="box cursor-pointer" (click)="selectAutomation(automation)"
                    [ngClass]="{'selected': selectedAutomations.includes(automation)}">
                    <img [src]="automation.imageUrl" alt="">
                    <div class="overlay"></div>
                    <div class="title-area">
                        <span>{{automation.title}}</span>
                    </div>
                </div>
                }
            </div>
        </div>
        }

        <!-- Contact details-->
        @case (4) {
        <div id="step4">
            <div class="texts">
                <span class="title">{{ 'journey_step4_title' | translate }}</span>
                <span class="subtitle">{{ 'journey_step4_subtitle' | translate }}</span>
            </div>
            <div class="input-area mt-3">
                <span class="label">{{ 'journey_step4_phone_label' | translate }}</span>
                <div class="phone-input-area">
                    <ng-select [items]="countries" bindLabel="phonePrefix" [placeholder]="'journey_step4_code_placeholder' | translate"
                        class="fyes-select country-code-select" [searchable]="false" [clearable]="false"
                        [(ngModel)]="selectedCountryCode">
                    </ng-select>
                    <input type="number" class="fyes-input phone-number-input" [placeholder]="'journey_step4_phone_placeholder' | translate"
                        [(ngModel)]="phoneNumber"
                        [ngClass]="{ 'is-invalid': phoneCtrl.touched && phoneNumber?.toString()?.length !== 10 }"
                        #phoneCtrl="ngModel" required>
                </div>
            </div>
            <div class="input-area mt-3">
                <span class="label">{{ 'journey_step4_email_label' | translate }}</span>
                <input type="email" class="fyes-input" [placeholder]="'journey_step4_email_placeholder' | translate" [(ngModel)]="email" email
                    required>
            </div>
        </div>
        }

        <!-- OTP Verification-->
        @case (5) {
        <div id="step5">
            <div class="texts">
                <span class="title">{{ 'journey_step5_title' | translate }}</span>
                <span class="subtitle">{{ 'journey_step5_subtitle' | translate }}</span>
            </div>
            <div class="otp-area">
                @if (remainingTime > 0) { <span class="time-left">{{ 'journey_step5_time_left' | translate }} {{displayTime}}</span>}
                @if (remainingTime === 0) { <span class="time-left invalid-color">{{ 'journey_step5_code_expired' | translate }}</span>}
                <form class="otp-boxes" [formGroup]="otpForm">
                    @for (inp of [].constructor(4); let i = $index; let f = $first; track i) {
                    <input type="text" inputmode="numeric" id="{{'code' + (i+1)}}" pattern="[0-9]*"
                        formControlName="{{'code' + (i+1)}}" class="form-control otp-box"
                        [class.is-invalid]="otpForm.get('code' + (i+1))?.invalid && otpForm.get('code' + (i+1))?.touched"
                        (input)="onInput(i)" (keydown)="validateInput($event); onKeyDown($event, i)" #input
                        [autofocus]="f" />
                    }
                </form>
                <div *ngIf="invalidCode" class="invalid-color fw-bold">{{ 'journey_step5_invalid_pin' | translate }}</div>
                <div class="resend-area">
                    <span class="receive-text">{{ 'journey_step5_no_code' | translate }}</span>
                    <button class="send-again-btn" [disabled]="resendRemainingTime !== 0" (click)="sendOTP(true)">
                        <span>{{ 'journey_step5_send_again' | translate }}</span>
                        @if (resendRemainingTime !== 0) {
                        <span class="ms-1">{{resendDisplayTime}}</span>
                        }
                    </button>
                </div>
            </div>
        </div>
        }

        <!-- Order details-->
        @case (6) {
        <div id="step6">
            <div class="texts">
                <span class="title">{{ 'journey_step6_title' | translate }}</span>
                <span class="subtitle">{{ 'journey_step6_subtitle' | translate }}</span>
            </div>
            <div class="details">
                <div class="detail">
                    <span class="label">{{ 'journey_step6_estimate' | translate }}</span>
                    <span class="value">{{ estimatedPriceLabel }}</span>
                </div>
                <div class="detail">
                    <span class="label">{{ 'journey_step6_space_type' | translate }}</span>
                    <span class="value">{{selectedSpaceType?.title}}</span>
                </div>
                <div class="detail">
                    <span class="label">{{ 'journey_step6_size' | translate }}</span>
                    <span class="value">{{selectedSize}} {{ 'journey_step6_sq_unit' | translate }}</span>
                </div>
                <div class="detail">
                    <span class="label">{{ 'journey_step6_rooms' | translate }}</span>
                    <span class="value">{{ selectedRooms ? (selectedRooms.labelKey | translate) : '' }}</span>
                </div>
                <div class="detail">
                    <span class="label">{{ 'journey_step6_automations' | translate }}</span>
                    <div class="d-flex gap-2 flex-wrap">
                        @for (automation of selectedAutomations; track $index) {
                        <div class="pill">
                            <i class="fa-light fa-lightbulb"></i>
                            <span>{{automation.title}}</span>
                        </div>
                        }
                    </div>
                </div>
            </div>
        </div>
        }
        <!-- Order confirmation-->
        @case (7) {
        <div id="step7" class="confirmation">
            <!-- <img src="assets/images/journey/checkmark-icon.svg" alt=""> -->
                              <ng-lottie
                 [options]="lottieOptions"
                 [styles]="{ width: '200px', height: '200px' }">
               </ng-lottie>
            <div class="confirmation-message">
                <span class="title">{{ 'journey_step7_title' | translate }}</span>
                <span class="description">{{ 'journey_step7_description' | translate }}</span>
            </div>

        </div>
        }
        }

        <div class="button-area">
            @if (currentStep < 5) { <button class="back-btn" (click)="goToStep(currentStep - 1)">{{ 'journey_back' | translate }}</button>
                <button class="primary-btn" [disabled]="disableNextButton()"
                    (click)="goToStep(currentStep + 1)">{{ 'journey_next' | translate }}</button>
                } @else if (currentStep === 5) {
                <!-- Verification is the only way forward: it issues the session the order needs -->
                <button class="back-btn" (click)="goToStep(currentStep - 1)">{{ 'journey_back' | translate }}</button>
                <button class="primary-btn" [disabled]="disableNextButton() || isVerifying"
                    (click)="submitOTPForm()">{{ 'journey_verify' | translate }}</button>
                } @else if (currentStep === 6) {
                <button class="back-btn" (click)="goToStep(1)">{{ 'journey_start_again' | translate }}</button>
                <button class="primary-btn" (click)="createOrder()" [disabled]="isSubmitting">{{ 'journey_send_quotation' | translate }}</button>
                } @else {
                <button class="primary-btn" (click)="goToStep(0)">{{ 'journey_back_to_home' | translate }}</button>
                }
        </div>

        <div class="help">
            @if (!isMobileView) { <span>{{ 'journey_help_troubles' | translate }}&nbsp;</span> }
            @if(isMobileView) { <img src="assets/images/homepage/fyes-logo-white.png" alt=""> }
            <div class="d-flex align-items-center cursor-pointer">
                <a href="/contact">{{ 'journey_help_get_help' | translate }}</a>
                <i class="fa-regular fa-circle-question ms-2" style="color: #46C5CC;"></i>
            </div>

        </div>
    </div>